<template>
  <div class="setup-wizard-general-info">
    <p class="setup-wizard-general-info__desc">
      {{ cards[activeCard].desc }}
    </p>
    <template>
      <label class="setup-wizard-general-info__input_label" :for="cards[activeCard].id">{{ cards[activeCard].id }}</label>
      <base-select
        v-if="['geo', 'locale'].includes(cards[activeCard].id)"
        class="setup-wizard-general-info__input"
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        :disabled="isDataUpdating"
        shiftLabelRight
        isSmartInput
        :smartInputStyle="{ 'padding-left': '20px' }"
        :placeholder="inputPlaceholderText"
        :options="inputOptions"
        v-model="data[cards[activeCard].id]"
        :selectStyle="{ height: '60px !important' }"
        :max-height-list="450"
      />
      <input
        v-else
        type="text"
        :disabled="isDataUpdating"
        v-model="data[cards[activeCard].id]"
        class="setup-wizard-general-info__input"
        :placeholder="inputPlaceholderText"
      >
    </template>
    <div class="navigation-controls">
      <button
        :disabled="isDataUpdating"
        @click="navigateBack"
        class="setup-wizard-general-info__btn setup-wizard-general-info__btn__back"
        :class="{'setup-wizard-general-info__btn__disabled': isDataUpdating}"
      >
        <div class="btn-content">
          <span class="btn-arrow btn-arrow-left"></span>
          BACK
        </div>
      </button>
      <button
        @click="navigateForward"
        class="setup-wizard-general-info__btn setup-wizard-general-info__btn__next"
        :class="{'setup-wizard-general-info__btn__disabled': isDataUpdating}"
        :disabled="isDataUpdating"
      >
        <div class="btn-content">
          {{ nextButtonText }}
          <span class="btn-arrow btn-arrow-right"
          v-if="activeCard < cards.length - 1"
          ></span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'

const CARDS = [
  {
    id: 'locale',
    desc: 'Select the Google engine for your keyword rank tracking'
  },
  {
    id: 'geo',
    desc: 'Select the default location for your keyword rank tracking'
  },
  {
    id: 'msv',
    desc: 'Choose the location label for your primary Monthly Search Volume values. Examples include US, Canada, Global.'
  }
]
export default {
  name: 'LocalityInfo',
  data () {
    return {
      errorFields: {},
      isDataUpdating: false,
      activeCard: 0,
      data: {
        locale: 184,
        geo: 343,
        msv: 'US'
      },
      cards: _.cloneDeep(CARDS)
    }
  },
  computed: {
    ...mapState('client', ['geo', 'device', 'locale']),
    inputPlaceholderText () {
      let text = this.cards[this.activeCard].id
      let label = text[0].toUpperCase() + text.slice(1)
      if (text === 'msv') label = label.toUpperCase()
      text = 'Select ' + label
      return text
    },
    inputOptions () {
      const currentField = this.cards[this.activeCard].id
      if (currentField === 'geo') {
        return this.geo || []
      } else if (currentField === 'locale') {
        return this.locale || []
      }
      return []
    },
    nextButtonText () {
      return 'NEXT'
    }
  },
  methods: {
    ...mapActions('accountSetup', ['completeSetup']),
    ...mapActions('client', ['getClientsSettings', 'getSetupOptions']),
    translateCardIndex (idx) {
      if (idx < 0) {
        return 0
      }
      if (idx > this.cards.length - 1) {
        return this.cards.length - 1
      }
      return idx
    },
    async navigateForward () {
      if (this.activeCard < this.cards.length - 1) {
        this.activeCard++
      } else {
        this.isDataUpdating = true
        
        // Store the locality data in Vuex
        this.$store.commit('accountSetup/setLocalityInfo', {
          ...this.data
        })
        
        // Navigate to next step without updating project yet
        this.$router.push({ name: 'setup-wizard-competitor-info' })
        this.isDataUpdating = false
      }
    },
    navigateBack () {
      if (this.activeCard > 0) {
        this.activeCard--
      } else {
        // If we're on the first card, go back to GeneralInfo
        this.$router.push({ name: 'setup-wizard-general-info' })
      }
    }
  },
  async created () {
    if (this.$route.hash) {
      this.activeCard = this.cards.findIndex(card => card.id === this.$route.hash.slice(1))
    }
    // Load the setup options for dropdowns
    await this.getSetupOptions()
  }
}
</script>

<style lang="scss" scoped>
  .btn-arrow {
    padding: 4px;
    border: solid $rfx-dark-march;
    border-width: 0 2px 2px 0;
    display: inline-block;
    margin-bottom: 1px;
  }
  .btn-arrow-right {
    transform: rotate(315deg);
    border-color: #fff;
  }
  .btn-arrow-left {
    transform: rotate(135deg);
  }

  .navigation-controls {
    display: flex;
    justify-content: space-between;
  }

  .setup-wizard-general-info {
    height: 30vh;
    width: 394px;
    margin: auto;
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 6px 16px 0 rgba(96, 97, 112, 0.2), 0 1px 4px 0 rgba(40, 41, 61, 0.06);
    padding: 48px;

    &__btn {
      text-align: center;
      margin: 0 5px;
      flex-grow: 1;
      outline: none;
      border: none;
      padding: 16px 9px;
      line-height: 24px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      border-radius: 8px;
      text-decoration: none;

      &__disabled {
        pointer-events: none;
        opacity: .4;
      }

      &:disabled {
        pointer-events: none;
        opacity: .4;
      }

      &__submit {
        background-color: $rfx-dark-march !important;
      }

      &__next {
        background-color: $rfx-bright-turquoise;
      }
      &__back {
        color: #000;
        background-color: $rfx-light-grey;
      }
    }

    &__input {
      display: inline-block;
      width: -webkit-fill-available;
      &[type="text"] {
        line-height: 24px;
        border-radius: 4px;
        // padding-left: 10px;
        // border: solid 1px #7c8e9b;
        border: 1px solid $rfx-light-steel;
        border-width: 2px;
        padding: 16px 16px 16px 10px;
        color: $rfx-medium-march !important;
        // margin: 1px;
        &::placeholder {
          color: $rfx-silver;
          font-size: 14px;
        }
      }
      margin: 0 5px 15px;

      &:disabled {
        background-color: #7c8e9b40;
      }

      &::placeholder {
        color: $rfx-medium-march;
      }

      &:focus {
        outline: none;
        // margin: 0;
      }

      &_error {
        border-color: $rfx-light-red;
      }

      &_error-message {
        display: inline-block;
        color: $rfx-light-red;
        margin-top: 8px;
        font-size: 14px;
        line-height: 16px;
      }

      &_wrapper {
        margin-bottom: 24px;

        &_error {
          margin-bottom: 16px;
        }

        &_confirm-password {
          margin-bottom: 0 !important;
        }
      }

      &_label {
        text-transform: uppercase;
        font-size: 14px;
        line-height: 16px;
        display: inline-block;
        font-weight: 500;
        color: $rfx-medium-march;
        margin: 0 5px 8px;
      }

      &_icon {
        display: block;
        font-size: 24px;
        color: $rfx-medium-march;
        width: 0;
        height: 0;
        position: relative;
        left: 18px;
        top: -18px;
      }
    }

    &__desc {
      margin: 0 0 16px;
      padding: 0;
      color: $rfx-dark-march;
      font-size: 18px;
      // font-weight: bold;
      text-align: center;
      height: 50px;
    }
    &__back {
      display: inline-block;
      color: $rfx-dark-march;
      font-size: 14px;
      line-height: 24px;
      font-weight: bold;
      margin-bottom: 24px;
      text-decoration: none;

    }

  }

</style>
